export const ISSUE_LABEL_NAME_MAX = 50;
export function normalizeIssueLabelName(name) {
    return name.normalize('NFKC').trim().replace(/\s+/gu, ' ');
}
/** OR within Labels, AND with the other issue filters. */
export function matchesIssueLabels(labels, selected) {
    return selected.length === 0 || selected.some(id => id === 'unlabeled' ? !labels?.length : labels?.some(label => label.id === id));
}
export function collectIssueLabels(issues) {
    return [...new Map(issues.flatMap(issue => issue.labels ?? []).map(label => [label.id, label])).values()]
        .sort((a, b) => a.name.localeCompare(b.name));
}
//# sourceMappingURL=issueLabels.js.map